import React, { useEffect, useState } from 'react'
import {
  getSynchronizationData,
  getSynchronizationMaterials,
  getFiltersEcualizador,
  postGraficaFiltrar,
  postGraficaEventos,
  postGeneralState,
  postMedidasPonderadas,
  deleteEventByID
} from '@auteco/services/snopServices'
import { MaterialsTableShared } from '../../components/snopComponents/MaterialsTableShared'
import BarChart from '../../components/snopComponents/BarChart/BarChart'
import Graph from '../../components/snopComponents/Graph/Graph'
import Notes from '../../components/snopComponents/Notes/Notes'

import { MaterialsFilters } from '../../components/snopComponents/MaterialsFilters'

import './SynchronizationPage.css'
import ButtonEventsSync from '@auteco/components/snopComponents/ButtonEventsSync/ButtonEventsSync'

const SynchronizatioPage = ({ state, getState }) => {
  const [filters, setFilters] = useState([])

  const [dataSynchronization, setDataSynchronization] = useState(null)
  const [filtersSaved, setFiltersSaved] = useState(null)
  const [materialsSynchronization, setMaterialsSynchronization] = useState([])
  const [currentPath, setCurrentPath] = useState()
  const [loading, setLoading] = useState(false)
  const [pointGraph, setPointsGraph] = useState([])
  const [eventGraph, setEventGraph] = useState([])
  const [notesActive, setNotesActive] = useState(false)
  const [medidasPonderadas, setMedidasPonderadas] = useState(null)

  const handleDeleteEventById = async (id) => {
    const response = await deleteEventByID(id)
    console.log(response)
    handleFilterEventsSaved()
    getMaterialsSynchronization()
  }

  const getFilters = async () => {
    const { filtros } = await getFiltersEcualizador()
    setFilters(filtros)
  }

  const handleEndCycle = async () => {
    if (state === 3) {
      await postGeneralState({ estado_id: 4 })
      getState()
    } else if (state === 4) {
      await postGeneralState({ estado_id: 5 })
      getState()
    }
  }

  const getMaterialsSynchronization = async () => {
    const response = await getSynchronizationMaterials()
    if (response) {
      setMaterialsSynchronization(response.materiales)
    }
  }

  const getInfoBars = async () => {
    const response = await getSynchronizationData()
    if (response) {
      setDataSynchronization(response)
    }
  }

  const handleViewDetails = ({ material }) => {}

  const handleUpdatedMaterials = () => {}

  const handleFilterMaterials = async ({ form }) => {
    getMaterialsSynchronization()
    setFiltersSaved(form)
    console.log(form, 'FORM')
    const datafiltered = await postGraficaFiltrar({ params: form })
    setPointsGraph(datafiltered)
    const datafilteredEventos = await postGraficaEventos({ params: form })
    console.log(datafilteredEventos)
    const datafilteredMedidas = await postMedidasPonderadas({ params: form })
    console.log(datafilteredMedidas)
    setMedidasPonderadas(datafilteredMedidas.medidas)
    setEventGraph(datafilteredEventos.eventos)
  }

  const handleFilterEventsSaved = async () => {
    const datafilteredEventos = await postGraficaEventos({ params: filtersSaved })
    setEventGraph(datafilteredEventos.eventos)
  }

  useEffect(() => {
    getInfoBars()
    getMaterialsSynchronization()
    getFilters()
  }, [])

  return (
    <div>
      <p className="title_sinc">Sincronización</p>
      {dataSynchronization && (
        <BarChart
          data={dataSynchronization}
          setCurrentPath={setCurrentPath}
          setLoading={setLoading}
          loading={setLoading}
        />
      )}

      <MaterialsFilters
        loading={loading}
        setLoading={setLoading}
        filters={filters}
        onFilter={handleFilterMaterials}
        currentPath={currentPath}
        selectNullGnombre
      />
      {filtersSaved && (
        <>
          {' '}
          <ButtonEventsSync filter={filtersSaved} handleFilterEventsSaved={handleFilterEventsSaved} />
          <Graph
            medidasPonderadas={medidasPonderadas}
            datosPuntos={pointGraph}
            datosEventos={eventGraph}
            handleDeleteEventById={handleDeleteEventById}
          />
          <MaterialsTableShared
            title="Listado de materiales"
            materials={materialsSynchronization}
            handleViewDetails={handleViewDetails}
            getUpdatedMaterials={handleUpdatedMaterials}
          />
        </>
      )}

      {!notesActive && (
        <button className="button-n" onClick={() => setNotesActive(true)}>
          Ver Notas
        </button>
      )}
      {notesActive && <Notes />}
      <br />
      {state === 3 && (
        <button className="button-n button-w" onClick={handleEndCycle}>
          Enviar a junta
        </button>
      )}
      {state === 4 && (
        <button className="button-n button-w" onClick={handleEndCycle}>
          Finalizar Ciclo
        </button>
      )}
    </div>
  )
}

export default SynchronizatioPage
